import React, { useEffect, useState } from 'react'
import { Editor, EditorMountEvent, EditorTools, EditorUtils, ProseMirror } from '@progress/kendo-react-editor'
import CustomButton from '../../stateless/customButton/CustomButton';
import "./RichTextEditor.scss";
import { Loader } from '@progress/kendo-react-indicators';

interface IRichTextEditor {
  content: string;
  onSave: (textContent: string) => void;
  height: string;
  isSaving?: boolean;
  readOnly?: boolean;
}

const { tableResizing } = EditorUtils;

/**
 *
 * @param content string - default content to populate the editor
 * @param onSave (textContent:string) => void - Function to save editor contents
 * @param height string - height property of the editor. Example "100vh"
 * @returns
 */
const RichTextEditor = (props: IRichTextEditor) => {
  const [content, setContent] = useState<any>(props.content);

  useEffect(() => {
    setContent(props.content);
  }, [props.content])

  const { EditorState, EditorView } = ProseMirror;

  const onMount = (event: EditorMountEvent) => {

    const { plugins, doc } = event.viewProps.state;

    return new EditorView(
      { mount: event.dom },
      {
        ...event.viewProps,
        state: EditorState.create({
          doc,
          plugins: [...tableResizing(), ...plugins],
        }),
      }
    );
  }

  const {
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Subscript,
    Superscript,
    ForeColor,
    BackColor,
    CleanFormatting,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    NumberedList,
    BulletedList,
    Undo,
    Redo,
    FontSize,
    FontName,
    FormatBlock,
    Link,
    Unlink,
    InsertImage,
    ViewHtml,
    InsertTable,
    InsertFile,
    SelectAll,
    Print,
    Pdf,
    AddRowBefore,
    AddRowAfter,
    AddColumnBefore,
    AddColumnAfter,
    DeleteRow,
    DeleteColumn,
    DeleteTable,
    MergeCells,
    SplitCell,
  } = EditorTools;

  useEffect(() => {
    if (!!props.readOnly) {
      let editor = document.getElementsByClassName('k-editor')[0];
      let iFrame = editor?.querySelector('iframe');
      var kContent = iFrame?.contentDocument?.querySelector('.k-content') as HTMLElement;

      if(kContent) {
        // Set pointer-events style for .k-content
        kContent.style.pointerEvents = 'none';
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div>
      <Editor
        onMount={onMount}
        tools={[
          [Bold, Italic, Underline, Strikethrough],
          [Subscript, Superscript],
          ForeColor,
          BackColor,
          [CleanFormatting],
          [AlignLeft, AlignCenter, AlignRight, AlignJustify],
          [Indent, Outdent],
          [OrderedList, UnorderedList],
          [NumberedList, BulletedList],
          FontSize,
          FontName,
          FormatBlock,
          [SelectAll],
          [Undo, Redo],
          [Link, Unlink, InsertImage, ViewHtml],
          [InsertTable, InsertFile],
          [Pdf, Print],
          [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
          [DeleteRow, DeleteColumn, DeleteTable],
          [MergeCells, SplitCell],
        ]}
        contentStyle={{ height: props.height, width: "100%" }}
        value={content}
        onChange={(event: any) => setContent(event.html)}
        onPasteHtml={(event: any) => {

          event.pastedHtml = event.pastedHtml.replace(new RegExp('<s>', 'g'), '<del>');
          event.pastedHtml = event.pastedHtml.replace(new RegExp('</s>', 'g'), '</del>');

          return event.pastedHtml;
        }}
      />
      {!props.readOnly && (
        <div>
          <CustomButton themeColor="primary" onClick={() => props.onSave(content)} disabled={!!props.isSaving}>
            {props.isSaving && (<Loader type="converging-spinner" size='small' themeColor='light'/>)}
            Save
          </CustomButton>
        </div>
      )}
    </div>
  )
}

export default RichTextEditor